import {
  GETBLOCKCUSTOMEROPERATIONSLIST_SUCCESS,
  GETBLOCKCUSTOMEROPERATIONSLIST_FAILED,
  RESET_GETBLOCKCUSTOMEROPERATIONSLIST,
  LOADING_GETBLOCKCUSTOMEROPERATIONSLIST,
  NETWORK_ERROR_GETBLOCKCUSTOMEROPERATIONSLIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETBLOCKCUSTOMEROPERATIONSLIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETBLOCKCUSTOMEROPERATIONSLIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETBLOCKCUSTOMEROPERATIONSLIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETBLOCKCUSTOMEROPERATIONSLIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETBLOCKCUSTOMEROPERATIONSLIST:
      return (state = initialState);
    default:
      return state;
  }
};
